<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange"></SearchField>

    <Table ref="table" :loading="loading" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'pcustom',
      getListUrl: 'freightrec',
      breadcrumb: [
        { name: "财务管理" },
        { name: "应付账款管理" },
      ],
      formInline: {},
      formCtrl: [
        // {
        //   ...this.ctrls.month
        // },
        {
          label: "公司名称",
          keyName: "company",
          placeholder: "请填写公司名称",
          type: "text",
        },
      ],
      cols: [
        { prop: "company", label: "公司名称", minwidth:120},
        { prop: "pname", label: "承运联系人" },
        { prop: "phone", label: "联系方式" },
        { prop: "address", label: "地址", minwidth:120},
        { prop: "money", label: "待结金额", align: 'right', className: 'pr30'},
      ],
      btns: [
        {
          title: '订单列表',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/finance/carrierOrder?shipperid=${id}`
            );
          },
        },
        {
          title: '打款记录',
          img: require('@/assets/img/shipper_order_list.png'),
          unimg: require('@/assets/img/shipper_order_list_hover.png'),
          cb: ({ id, pname }) => {
            this.$router.push(
              `/finance/carrierPaymentHistory?shipperid=${id}&pname=${pname}`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>
